<script lang="ts" setup>
import { ref } from 'vue'

import Logo from '@/assets/svg/logo.svg'
import LogoCompact from '@/assets/svg/logo-compact.svg'

import { useBreakpoint } from './composables/useBreakpoint'

const bp = useBreakpoint()

defineOptions({ name: 'SitePreloader' })

const visible = ref(true)

defineExpose({ visible })
</script>

<template>
  <div id="app-loading-container">
    <Transition>
      <div v-if="visible" class="preloader">
        <div class="preloader-content">
          <div v-if="bp.ltLg" class="logo-compact">
            <LogoCompact />
            <LogoCompact />
          </div>
          <div v-else class="logo">
            <Logo />
            <Logo />
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<style lang="scss" scoped>
.preloader {
  position: fixed;
  z-index: 1000;
  background-color: #2C2C2C;
  color: #fff;
  inset: 0;
}

.preloader-content {
  display: flex;
  overflow: hidden;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
}

.logo-compact {
  position: relative;
  overflow: hidden;
  width: 46px;
  height: 41px;
}

.logo {
  position: relative;
  overflow: hidden;
  width: 230px;
  height: 36px;
}

svg {
  position: absolute;

  &:nth-child(2) {
    animation: reveal 2s infinite ease-in-out;
      clip-path: inset(0 0 0 0);
    color: #000;
    opacity: 0.3;
  }
}

@keyframes reveal {
  0% {
    clip-path: inset(0 0 0 0);
  }

  25% {
    clip-path: inset(0 0 0 100%);
  }

  75% {
    clip-path: inset(0 100% 0 0);
  }

  100% {
    clip-path: inset(0 0 0 0);
  }
}
</style>
